import PubSub from "underpub-js";

var HighlightMedia = function (options) {

  this.options = {
    $el: false,
    baseClass: 'mol-HighlightMedia',
  };

  $.extend(true, this.options, options);

};

HighlightMedia.prototype.init = function () {

  var self = this;

};

export default HighlightMedia;